module.exports = __webpack_public_path__ + "static/media/awards_2.30cef850.jpg";